<script setup lang="ts">
import AuthorizedSidebarLinkWrapper from './AuthorizedSidebarLinkWrapper.vue';
import SidebarLink from './SidebarLink.vue';
import { useRouter, type RouteLocationRaw } from 'vue-router';
import { computed, type Component } from 'vue';
import Feature from './Feature.vue';

const { to } = defineProps<{
    to: RouteLocationRaw;
    icon?: Component;
    img?: string;
    title: string;
    comingSoon?: boolean;
    newFeature?: boolean;
}>();

const router = useRouter();
const route = router.resolve(to);
const permissions = computed(() => {
    const permissions = route.meta.permissions;
    if (!permissions) return undefined;

    return Array.isArray(permissions) ? permissions : [permissions];
});

const featureFlags = computed(() => {
    const featureFlags = route.meta.featureFlags;
    if (!featureFlags) return [];

    return Array.isArray(featureFlags) ? featureFlags : [featureFlags];
});
</script>

<template>
    <Feature :featureFlags="featureFlags">
        <AuthorizedSidebarLinkWrapper :permissions="permissions">
            <SidebarLink
                :to="to"
                :title="title"
                :icon="icon"
                :img="img"
                :coming-soon="comingSoon"
                :new-feature="newFeature"
            />
        </AuthorizedSidebarLinkWrapper>
    </Feature>
</template>
